import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VerifyInvitationResponse } from '../model/course.model';

@Injectable({ providedIn: 'root' })
export class CourseService {
  private _httpClient = inject(HttpClient);
  private platformId = inject<object>(PLATFORM_ID);
  private isLocalhost =
    isPlatformBrowser(this.platformId) && window.location.hostname.includes('localhost');

  verifyCourseInvitation(invitationToken: string): Observable<VerifyInvitationResponse> {
    return this._httpClient.get<VerifyInvitationResponse>(
      environment.courseApiUrl + `invitations/validate?token=${invitationToken}`,
      { withCredentials: isPlatformBrowser(this.platformId) && !this.isLocalhost }
    );
  }

  claimCourse(inviteSessionToken: string): Observable<unknown> {
    return this._httpClient.post<unknown>(environment.courseApiUrl + `invitations/claim`, {inviteSessionToken} );
  }
}
